import React, { useEffect, useState } from 'react';
import { Card, CardTitle } from '../components/UI';
import { listShipments } from '../api';
import { Loader2, ChevronRight } from 'lucide-react';

export default function Shipments({ onOpen }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await listShipments();
        setRows(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Card>
      <CardTitle>Shipments</CardTitle>
      {loading ? (
        <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--lf-muted)' }}>
          <Loader2 className="animate-spin" size={14} /> Loading…
        </div>
      ) : rows.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--lf-muted)' }}>No shipments yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-[13px] border-collapse">
            <thead>
              <tr>
                {['ID', 'Lane', 'Equipment', 'ETA', 'Projected cost', ''].map((h) => (
                  <th
                    key={h || 'arrow'}
                    className="text-left p-3 font-semibold"
                    style={{ borderBottom: '1px solid var(--lf-line)' }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => (
                <tr
                  key={s.id}
                  data-testid={`shipment-row-${s.shipment_code}`}
                  onClick={() => onOpen && onOpen(s.id)}
                  className="transition-colors"
                  style={{ cursor: onOpen ? 'pointer' : 'default' }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = '#f8faff')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                >
                  <td className="p-3 font-medium" style={{ borderBottom: '1px solid var(--lf-line)' }}>
                    {s.shipment_code}
                  </td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>{s.lane}</td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>{s.equipment}</td>
                  <td className="p-3" style={{ borderBottom: '1px solid var(--lf-line)' }}>{s.eta}</td>
                  <td className="p-3 font-semibold" style={{ borderBottom: '1px solid var(--lf-line)' }}>
                    {s.projected_cost}
                  </td>
                  <td className="p-3 text-right" style={{ borderBottom: '1px solid var(--lf-line)', color: 'var(--lf-muted)' }}>
                    <ChevronRight size={16} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
